<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  (onHide)="close.emit()"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  [style]="{ width: '55vw', maxWidth: '1024px' }"
  [breakpoints]="{ '1200px': '70vw', '992px': '80vw', '768px': '90vw', '576px': '95vw' }"
>
  <div class="dialog-body">
    @if (fileType === undefined || fileUrl === undefined) {
      <div class="empty-state">File Type not found</div>
    }

    @if (fileType === 'doc' || fileType === 'pdf') {
      <div class="viewer-wrapper">
        <app-file-viewer [visible]="true" [fileUrl]="fileUrl" [fileName]="fileName"></app-file-viewer>
      </div>
    }

    @if (fileType === 'image') {
      <div class="media-wrapper">
        <img [src]="fileUrl" [alt]="fileName" class="dialog-image" />
      </div>
    }

    @if (fileType === 'video') {
      <div class="media-wrapper">
        <video controls controlsList="nodownload" class="dialog-video">
          <source [src]="fileUrl" />
        </video>
      </div>
    }

    @if (fileType === 'audio') {
      <div class="audio-wrapper">
        <audio controls controlsList="nodownload" class="dialog-audio">
          <source [src]="fileUrl" />
        </audio>
      </div>
    }
  </div>
</p-dialog>
